import Repository from "@shared/services/api/abstracts/Repository";
import { ProductTypeSerializer } from "../types/products";

export default class PublicBasedProductsRepository extends Repository<ProductTypeSerializer> {
  public readonly repositoryName = "PublicBasedProductsRepository";

  public readonly endpoint = "api/public/products/";
}
